.dots {
  gap: 8px;
  margin-top: 12px;
}

.dot {
  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: rgb(17 17 17 / 25%);
  transition: width 0.3s ease, background 0.3s ease;
}

/* active dot: wider pill; solid fill = static (auto-advance off) */
.active {
  width: 20px;
  background: rgb(17 17 17 / 65%);
  position: relative;
  overflow: hidden;
}

/* with a fill span (auto-advance on), the pill is a translucent track for the fill */
.active:has(.fill) {
  background: rgb(17 17 17 / 20%);
}

.fill {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: rgb(17 17 17 / 65%);
  transform: scaleX(0);
  transform-origin: left center;
  animation-name: dot-fill;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

@keyframes dot-fill {
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
}

@media all and (--reefer-media-tablet-min) {
  .dots {
    margin-top: 16px;
  }

  .dot {
    width: 8px;
    height: 8px;
  }

  .active {
    width: 28px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .dot {
    transition: none;
  }

  .fill {
    animation: none;
    transform: scaleX(1);
  }
}
